// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UwXZ","importantInfo":"styles_importantInfo__1pXpi"};